import { Control, Controller, ControllerRenderProps } from 'react-hook-form'

import { Box, Flex } from '@chakra-ui/react'

import { radioButtonBorderStyles } from '@/styles/utils'
import { areValuesEqual } from '@/utils/equality'
import { OptionI } from '@/utils/forms/optionBuilders'

import { RadioButton } from '../RadioButton'

interface RadioSelectIProps<T = unknown> {
  options: OptionI<T>[]
  defaultValue: OptionI<T>
  control: Control
  id: string
}

const getDefaultIndex = <T,>(
  options: OptionI<T>[],
  defaultValue: OptionI<T> | null
): number | null => {
  if (!defaultValue?.value) return null
  const index = options.findIndex((option) =>
    areValuesEqual(option.value, defaultValue.value)
  )
  return index >= 0 ? index : null
}

export const RadioSelect = <T = unknown,>({
  options,
  control,
  id,
  defaultValue,
}: RadioSelectIProps<T>) => {
  const onOptionSelect = (
    index: number,
    selectedIndex: number | null,
    onChange: (value: OptionI<T> | null) => void
  ) => {
    const updatedIndex = index === selectedIndex ? null : index
    const newValue = updatedIndex !== null ? options[updatedIndex] : null
    onChange(newValue)
  }

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={id}
      render={({ onChange, value }: ControllerRenderProps) => {
        const selectedIndex = getDefaultIndex(options, value)

        return (
          <Box>
            <Flex direction='column' gap='8px' py='15px'>
              {options?.map((item, index) => (
                <RadioButton
                  color='black'
                  isActive={selectedIndex === index}
                  key={
                    item.value !== null && item.value !== undefined
                      ? String(item.value)
                      : index
                  }
                  label={item.label}
                  onClick={() => onOptionSelect(index, selectedIndex, onChange)}
                  radioButtonStyles={radioButtonBorderStyles}
                />
              ))}
            </Flex>
          </Box>
        )
      }}
    />
  )
}
